import React, { Component } from "react";
import { reduxForm } from "redux-form";

import Button from "../../../../components/form/Button";
import Select from "../../../../components/form/Select";
import DateTimePicker from "../../../../components/form/DateTime";
import Input from "../../../../components/form/Input";
import CroField from "../generalForm/CroField";
import { styles } from "../../index";
import { asyncForm } from "../../../../utils/asyncForm";
import * as V from "../../../../utils/formValidation";
import askAction from "../AskAction";

import { InspectionResult, InspectionResultEnum, InspectionType, InspectionTypeEnum } from "../../enum";
import AutoComplete from "../../../../components/form/AutoComplete";

class InspectionForm extends Component {

  componentDidMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      onDelete,
      submitting,
      askAction,
      result,
      type,
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form long-label inspectionForm"
      >
        <div className="inspectionForm__section">
          <div className="inspectionForm__grid">
            <CroField
              className="third"
              title="Typ kontroly"
              name="type"
              component={Select}
              items={InspectionTypeEnum}
              fullWidth
              disabled
            />

            <CroField
              className="third"
              title="Datum kontroly"
              name="inspectionDate"
              component={DateTimePicker}
              useISO
              fullWidth
              noIcon
              validate={[V.required]}
            />

            <CroField
              title="Výsledek kontroly"
              name="result"
              component={Select}
              items={InspectionResultEnum}
              fullWidth
            />

            {result === InspectionResult.PROBLEM && (
              <CroField
                title="Předáno přestupkovému orgánu"
                name="forwardedTo"
                component={AutoComplete}
                fullWidth
                url="/api/ciselniky/spravni-organ"
                validate={[V.required, V.isDictionary]}
              />
            )}
          </div>
        </div>

        {type === InspectionType.ONGOING_STATEMENT && (
          <div className="inspectionForm__section">
            <div className="inspectionForm__grid">
              <CroField
                  title="Období od"
                  name="periodFrom"
                  component={DateTimePicker}
                  fullWidth
                  noIcon
                  disabled
              />

              <CroField
                  title="Období do"
                  name="periodTo"
                  component={DateTimePicker}
                  fullWidth
                  noIcon
                  disabled
              />
            </div>
          </div>
        )}

        {result === InspectionResult.PROBLEM && (
          <div className="inspectionForm__section">
            <CroField
                title="Poznámka"
                name="note"
                component={Input}
                fullWidth
                multiline
                rows={4}
            />
          </div>
        )}

        <div className="inspectionForm__footer">
            <div className="inspectionForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="inspectionForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="inspectionForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Zpět"
                  disabled={submitting}
                  onClick={() => this.props.router.goBack()}
                />
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting}
                  onClick={handleSubmit(onSubmit)}
                />
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Smazat"
                  disabled={submitting}
                  onClick={askAction(
                    onDelete,
                    "Opravdu chcete smazat tuto kontrolu?",
                  )}
                />
              </div>
            </div>
          </div>
      </form>
    );
  }
}

export default reduxForm({
  form: "inspectionForm",
})(askAction(asyncForm(InspectionForm)));
